'use strict';

export default class Hero {
  constructor() {
    this.name = 'hero';
    let parent = document.getElementsByClassName('parallax-container')[0];
    if (parent) {
      let children = parent.getElementsByTagName('div');
      window.addEventListener('scroll', () => {
        for (let i = 0; i < children.length; i++) {
          children[i].style.transform = 'translateY(-' + (window.pageYOffset * i / children.length) + 'px)';
        }
      }, false);
    }
  }
}
